
<template>
  <div>
    <v-toolbar flat color="white">
      <!-- <v-toolbar-title>Perfis</v-toolbar-title>
      <v-spacer></v-spacer>-->

      <RepresentativeForm
        :addButton="true"
        :dialog="prepositoryDialog"
        :openForm="() => openDialogForm()"
        :closeForm="() => closeDialogForm()"
        :savePrepository="(data) => savePrepository(data)"
        :editFormData="formData"
      />
    </v-toolbar>
    <SearchRepresentative
      :searchPrepositorys="(prepository) => getRepresentatives(prepository)"
    />
    <v-data-table :headers="headers" :items="tableData">
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.representative_name }}</td>
        <td class="text-xs-left">{{ props.item.representative_email }}</td>
        <td class="text-xs-left">
          {{ props.item.representative_tell | formatTell }}
        </td>
        <td class="text-xs-center layout">
          <!-- v-if="profilesPermissions && profilesPermissions.view" -->
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                small
                class="mr-2"
                @click="editItem(props.item, 'viewForm')"
                >remove_red_eye</v-icon
              ></template
            >
            <span>Visualizar</span>
          </v-tooltip>
          <!-- v-if="profilesPermissions && profilesPermissions.edit" -->
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="editItem(props.item)"
                >edit</v-icon
              ></template
            >
            <span>Editar</span>
          </v-tooltip>
          <!-- v-if="profilesPermissions && profilesPermissions.remove" -->
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small @click="confirmDelPrepository(props.item)"
                >delete</v-icon
              ></template
            >
            <span>Excluir</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-data>
        <p>Não há dados</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import RepresentativeForm from './RepresentativeForm.vue'
import SearchRepresentative from './SearchRepresentative.vue'
import { representatives } from '@/services/providers/representative'

export default {
  name: 'Representative',

  components: {
    RepresentativeForm,
    SearchRepresentative
  },

  data () {
    return {
      prepositoryDialog: false,
      formData: null,
      headers: [
        { text: 'Preposto', sortable: true, value: 'representative_name' },
        {
          text: 'E-mail',
          value: 'representative_email',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Telefone',
          value: 'representative_tell',
          sortable: false,
          align: 'left'
        },
        { text: ' ', value: '', sortable: false, align: 'center' }
      ],
      tableData: []
    }
  },

  mounted () {
    this.getRepresentatives()
  },

  methods: {
    confirmDelPrepository (data) {
      let obj = {
        message: `Você deseja excluir o preposto "${data.representative_name}"?`,
        title: 'Excluir preposto',
        callback: (_) => {
          this.delPrepository(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    delPrepository (data) {
      let obj = {
        url: '/api/representative/' + data.id,
        query: '',
        method: 'delete'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Preposto removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.getRepresentatives()
      })
    },

    openDialogForm () {
      this.formData = null
      this.prepositoryDialog = true
    },

    closeDialogForm () {
      this.prepositoryDialog = false
    },

    async getRepresentatives (prepository = {
      prepository_name: ''
    }) {
      this.tableData = await representatives(prepository)
    },

    editItem (item, view) {
      // if (!item.permissions_id) {
      //   item.permissions_id = item.permissions.map(perm => {
      //     return perm.id;
      //   });
      // }
      view === 'viewForm' ? (item.view = true) : (item.view = false)
      this.formData = Object.assign({}, item)
      this.prepositoryDialog = true
    },

    savePrepository (data) {
      let id = data.id ? `/${data.id}` : ''
      let typeMethod = data.id ? 'patch' : 'post'

      // data.type = "master";
      // data.profile_id = 1;

      let obj = {
        url: '/api/representative' + id,
        query: data,
        method: typeMethod
      }
      console.log(obj)
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Perfil ${id ? 'alterado' : 'criado'} com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.prepositoryDialog = false
        this.getRepresentatives()
      })
    }
  },

  filters: {
    formatTell (val) {
      return val.replace(/^(\d{2})(\d)/g, '($1) $2').replace(/(\d)(\d{4})$/, '$1-$2')
    }
  }
}
</script>
